export default {"src":"/_next/static/media/next-arrow.9fecaf0f.svg","height":68,"width":68,"blurWidth":0,"blurHeight":0};